import {useState} from 'react'
import {Flex, Text, Box, Link} from '@chakra-ui/react'
import {Button, Form, Input} from 'antd'
import {CommonColors} from '@utils/CommonStyles'
import {useLocation, useNavigate} from 'react-router-dom'
import {LOCAL_STORAGE, PATH, SCREEN_TRACKING, STATUS_CODE} from '@utils/Const'
import appRequest from '@apis/app'
import {trackingPage} from '@utils'
import Loading from '@components/Loading'

const VerifyPassword = ({user}: {user: any}) => {
  const {entry_point, task_id} = useLocation()?.state || {}
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const onFinish = async (values: any) => {
    setIsLoading(true)

    const userData = {
      ...user,
      password: values?.password,
    }

    const res = await appRequest.register(userData)

    if (res?.data?.status === STATUS_CODE.SUCCESS) {
      const loginData = await appRequest.login(userData)
      localStorage.setItem(
        LOCAL_STORAGE.ACCESS_TOKEN,
        loginData?.data?.data?.access_token,
      )
      localStorage.setItem(
        LOCAL_STORAGE.REFRESH_TOKEN,
        loginData?.data?.data?.refresh_token,
      )
      localStorage.setItem(
        LOCAL_STORAGE.USER_ID,
        loginData?.data?.data?.user_id,
      )
      trackingPage(SCREEN_TRACKING.REGISTER_SUCCESS)

      if (entry_point === 'ROADMAP') {
        navigate(PATH.ROADMAP_SUMMARY, {
          state: {
            task_id,
            is_new_register: true,
          },
        })
      } else {
        navigate(PATH.HOME, {replace: true})
      }
    }

    setIsLoading(false)
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Box sx={styles.form} w={{base: '100%', md: '480px'}} mx={'16px'}>
      {isLoading && <Loading />}
      <Flex flexDirection={'column'}>
        <Text sx={styles.title}>Nhập mật khẩu</Text>
        <Form
          name="basic"
          layout={'vertical'}
          autoComplete="off"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}>
          <Form.Item
            label="Mật khẩu"
            name="password"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập mật khẩu!',
              },
            ]}>
            <Input.Password />
          </Form.Item>

          <Form.Item
            label="Nhập lại mật khẩu"
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập lại mật khẩu!',
              },
              ({getFieldValue}) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(
                    new Error('Mật khẩu nhập lại không khớp!'),
                  )
                },
              }),
            ]}
            validateTrigger="onChange"
            validateFirst>
            <Input.Password />
          </Form.Item>
          <Form.Item style={{marginTop: '30px'}}>
            <Button htmlType="submit" type="primary" style={styles.button}>
              Tiếp tục
            </Button>
          </Form.Item>
          <Text sx={styles.textRegister}>
            <Link
              color="#1890FF"
              onClick={() => navigate(PATH.LOGIN)}
              ml={'6px'}>
              Thay đổi số điện thoại
            </Link>
          </Text>
        </Form>
      </Flex>
    </Box>
  )
}

const styles = {
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column',
    backgroundColor: CommonColors.blue1,
  },
  form: {
    flexDirection: 'column',
    backgroundColor: CommonColors.white,
    padding: 8,
    alignItems: 'center',
    borderRadius: '24px',
    justifyContent: 'center',
  },
  button: {
    width: '100%',
    borderRadius: '12px',
    backgroundColor: CommonColors.blue2,
    height: '46px',
  },
  textRegister: {
    fontWeight: 600,
    fontSize: '14px',
    textAlign: 'center',
  },
  title: {
    fontWeight: 600,
    fontSize: '24px',
    textAlign: 'center',
  },
}

export default VerifyPassword
